export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtZakazkapa';

export const NAME = 'ZakazkaZapujcka';
